export enum ProfileFormFieldsNames {
  FullName = 'fullName',
}

export interface ProfileFormFields {
  [ProfileFormFieldsNames.FullName]: string;
}
